import axios from 'axios';
import {environment} from 'environment';
import qs from 'qs';

/**
 * Axios instance for all `report` api requests.
 *
 * An `axios` instance utilising `axios-cache-adapter` and `localforage` for
 * caching responses to localStorage.
 */
const reportApi = axios.create({
  baseURL: `${environment.endpoint('report')}/report/api`,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export default reportApi;
